import React from "react";
import { FiChevronDown } from "react-icons/fi";
import { IoDuplicateOutline } from "react-icons/io5";

export default function SaleHistory() {
  return (
    <div
      style={{
        fontSize: "14px",
        backgroundColor: "#fff",
        padding: "10px 20px",
        width: "100%",
        marginTop:"-30px",
      }}
    >
      {/* Header */}
      <div style={{display:"flex", justifyContent:"space-between"}}>
      <div style={{ fontWeight: "600", marginBottom: "10px", fontSize: "20px" }}>
        Patient’s Sale History
        <div style={{ fontSize: "11px", color: "#888" }}>
         View or replicate from list below
        </div>
      </div>
      <button style={{ display: "flex",
        justifyContent: "flex-end", 
        alignSelf:"flex-end",
        gap: "6px",
        backgroundColor: "#3d404b",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "6px 14px",
        fontSize: "15px",
        fontWeight: 500,
        cursor: "pointer",}}>
        Save(F2)
      </button>
     </div>
      {/* Patient Info */}
      <div
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "20px",
  }}
>
  {/* Avatar */}
  <div
    style={{
      width: "55px",
      height: "55px",
    backgroundColor: "#cfd8ff",
      borderRadius: "12px", // Rounded square
      textAlign: "center",
      lineHeight: "55px",
      fontWeight: "bold",
      fontSize: "20px",
        color: "#333",
      flexShrink: 0,
    }}
  >
    HA
  </div>

  {/* Info Section */}
  <div style={{ fontSize: "14px", color: "#333" }}>
    <div style={{ fontWeight: "bold", fontSize: "15px", color: "#000" }}>JANE</div>
    <div style={{ color: "#888", marginBottom: "8px" }}>Female (22Y)</div>

    {/* Details below gender */}
    <div>
      <div>
        <span style={{ color: "#777", marginRight: "8px" }}>First Sale</span>
        <span style={{fontWeight:"500"}}>15–Aug–2025</span>
      </div>
      <div>
        <span style={{ color: "#777", marginRight: "8px" }}>Contact</span>
        <span style={{fontWeight:"500"}}> 645357589</span>
      </div>
      <div>
        <span style={{ color: "#777", marginRight: "8px" }}>Address</span>
        <span style={{fontWeight:"500"}}>Vizag</span>
      </div>
    </div>
  </div>
</div>

      {/* Branch Tabs */}
      <div style={{ display: "flex", gap: "20px", marginBottom: "16px" }}>
        <div
          style={{
            fontWeight: "600",
            color: "#72c390ff",
            borderBottom: "2px solid #7eb592",
            paddingBottom: "6px",
            cursor: "pointer",
          }}
        >
          THIS BRANCH (1)
        </div>
        <div style={{ color: "#aaa", fontWeight: "500" }}>OTHER BRANCHES (0)</div>
      </div>

      {/* Invoice Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: "10px 14px",
          borderRadius: "6px",
          marginBottom: "10px",
        }}
      >
        <div style={{display:"flex",justifyContent:"space-evenly", gap:"80px"}}>
        <span style={{ color: "#333", fontSize: "14px",marginRight:"10px" }}>
          15-Aug-2025             
        </span>
        <span style={{ color: "#333", fontSize: "14px" ,marginRight:"10px" }}>
                    Invoice/1              
        </span>
        <span style={{ color: "#333", fontSize: "14px" ,marginRight:"10px" }}>
                      ₹322
        </span>
        </div>
        <span
          style={{
            fontSize: "13px",
            color: "#7eb592",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            cursor: "pointer",
          }}
        >
          1 product <FiChevronDown />
        </span>
      </div>

      {/* Product Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "13.5px",
          marginBottom: "16px",
        }}
      >
        <thead>
          <tr style={{ textAlign: "left", color: "#666" ,borderBottom:"1px dashed #c2bdbdff" }}>
            <th style={{ paddingBottom: "8px" }}>Product</th>
            <th>Qty</th>
            <th>MRP</th>
            <th>Rate</th>
            <th>Disc%</th>
          </tr>
        </thead>
        
        <tbody>
          <tr style={{ color: "#333" }}>
            <td style={{ padding: "6px 0" }}>Ibuprufen 500 mg</td>
            <td>2</td>
            <td>₹182.81</td>
            <td>₹160.87</td>
            <td>12%</td>
          </tr>
        </tbody>
      </table>

     
     
{/* Replicate Button */}
<div
  style={{
    backgroundColor: "#f2e6ff",
    padding: "12px",
    textAlign: "center",
    borderRadius: "6px",
    fontWeight: "600",
    color: "#689b7aff",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    display: "flex", // enables icon and text to sit side-by-side
    justifyContent: "center",
    alignItems: "center",
    gap: "8px", // spacing between icon and text
  }}
  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#ebd7ff")}
  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#f2e6ff")}
>
  <IoDuplicateOutline size={18} />
  Replicate this Invoice     
</div>

    </div>
  );
}
